// src/Base64Converter.js
import React, { useState } from 'react';
import { Container, Row, Col, Button, Form, Card } from 'react-bootstrap';

const Base64Converter = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [fileName, setFileName] = useState('');

  const handleConvert = () => {
    try {
      const encoded = btoa(input); // Encodage en base64
      setOutput(encoded);
    } catch (error) {
      setOutput('Erreur lors de la conversion');
    }
  };

  function handleDecode() {
    try {
      const decoded = atob(input); // Décodage en base64
      setOutput(decoded);
    } catch (error) {
      setOutput('Erreur lors du décodage');
    }
  }

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);  // Enregistre le nom du fichier source
      const reader = new FileReader();
      reader.onload = (e) => {
        setInput(e.target.result);
      };
      reader.readAsText(file);
    }
  };

  const handleDownload = () => {
    const blob = new Blob([output], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    
    // Modifie le nom du fichier de sortie
    const baseName = fileName.replace(/\.[^/.]+$/, ""); // Enlève l'extension
    const extension = fileName.split('.').pop(); // Récupère l'extension
    link.download = `${baseName}64.${extension}`; // Ajoute "64" avant l'extension
    
    link.click();
    URL.revokeObjectURL(url);
  };

  const handleClear = () => {
    setInput('');
    setOutput('');
    setFileName('');
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card>
            <Card.Header as="h5" className="text-center">Convertisseur Base64</Card.Header>
            <Card.Body>
              <Form.Group controlId="formFileUpload">
                <Form.Label>Téléchargez un fichier</Form.Label>
                <Form.Control
                  type="file"
                  accept=".txt"
                  onChange={handleFileUpload}
                />
              </Form.Group>
              <Form.Group controlId="formInput" className="mt-3">
                <Form.Label>Texte à convertir / décoder</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={6}
                  placeholder="Entrez le texte ici ou téléchargez un fichier..."
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                />
              </Form.Group>
              <Button variant="primary" onClick={handleConvert} className="mt-3">
                Convertir en Base64
              </Button>
              <Button 
                variant="warning" 
                onClick={handleDecode} 
                className="mt-3 ms-2"
              >
                Décoder Base64
              </Button>
              <Button 
                variant="success" 
                onClick={handleDownload} 
                className="mt-3 ms-2"
                disabled={!output}
              >
                Télécharger le résultat
              </Button>
              <Button 
                variant="secondary" 
                onClick={handleClear} 
                className="mt-3 ms-2"
              >
                Effacer
              </Button>
              <Form.Group controlId="formOutput" className="mt-3">
                <Form.Label>Résultat</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={6}
                  placeholder="Le résultat apparaîtra ici..."
                  value={output}
                  readOnly
                />
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Base64Converter;
